import PassIncomplete from "./pass-incomplete";
import PassResultType from "../enums/pass-result-type";

export default class PassBrokenUp extends PassIncomplete {
    constructor(intendedFor, brokenUpBy) {
        super(intendedFor, brokenUpBy);

        this.passResultCode = PassResultType.BROKEN_UP.code;
        this.code = PassBrokenUp.getCode();
    }

    static getCode() {
        return "BRUP";
    }
}
